import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../lib/AuthContext';

const ProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();

    // If still loading, show a simple loading state
    if (loading) {
        return <div className="flex min-h-screen items-center justify-center">Loading...</div>;
    }

    // If not authenticated, redirect to login
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // Otherwise, render the protected content
    return children;
};

export default ProtectedRoute; 